export default __webpack_public_path__ + "static/media/13_128gb_hong.6e4c097f.jpg";